export const employeeEngagementMethods = {
    methods: {
        getEmployeeEngagementIndicationScore(uwes, evaluation) {
            let employeeEngagementIndexAverage = Math.round((uwes.engagementScaleAverage + evaluation.evaluationScaleAverage)/2)


            return employeeEngagementIndexAverage
        },
        getChartDataEEI(employeeEngagement) {
            const chartData = {
                datasets: [
                    {
                        data: [
                            employeeEngagement,
                            100 - employeeEngagement,
                        ],
                        backgroundColor: [
                            this.adjustColor(employeeEngagement),
                        ],
                        borderWidth: 0,
                    },
                ],
                labels: [""],
            };
    
            return chartData;
        }



    },
    
}